module.exports = __webpack_public_path__ + "static/media/date-un-shot.48194877.jpg";